module.exports = __webpack_public_path__ + "b2ce2f2c300a71bbe9fafb6f48f6a4a6.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/de.json
// module id = 1116
// module chunks = 0